import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

function buildServerPublicClient() {
  const url = process.env.SUPABASE_URL;
  const key = process.env.SUPABASE_PUBLISHABLE_KEY;
  if (!url || !key) throw new Error("supabase_env_missing");
  return createClient<Database>(url, key, {
    auth: { storage: undefined, persistSession: false, autoRefreshToken: false },
    global: {
      fetch: (input, init) => {
        const headers = new Headers(init?.headers);
        headers.set("apikey", key);
        return fetch(input, { ...init, headers });
      },
    },
  });
}

export type PublicVideoSpecial = {
  id: string;
  dish_id: string;
  video_url: string;
  poster_url: string;
  sales_description: string | null;
  sort_order: number;
  dish: {
    id: string;
    name: string;
    description: string;
    alacarte_price_paise: number | null;
    image_url: string | null;
    is_active: boolean;
    meal_slot: string;
    is_veg: boolean | null;
    calories_kcal: number | null;
  };
};

export const listPublicVideoSpecials = createServerFn({ method: "GET" }).handler(
  async (): Promise<PublicVideoSpecial[]> => {
    try {
      const supabase = await import("@/integrations/supabase/client.server").then(m => m.supabaseAdmin);
      const { data, error } = await supabase
        .from("video_specials" as any)
        .select(`
          id, dish_id, video_url, poster_url, sales_description, sort_order,
          dish:mp2_dishes(
            id, name, description, alacarte_price_paise, image_url, 
            is_active, meal_slot, is_veg, calories_kcal
          )
        `)
        .eq("is_active", true)
        .order("sort_order", { ascending: true })
        .limit(6);

      if (error) {
        console.error("[video-specials] read failed", error);
        return [];
      }
      return (data ?? []) as any[];
    } catch (err) {
      console.error("[video-specials] unexpected error", err);
      return [];
    }
  }
);
